// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://admin.smart-taung-thu.com/api',
  version: '1.0.1',
  firebaseConfig: {

    apiKey: "AIzaSyAFsyoox3Tsfmd_lxmSLSXYmO-7HCqohk8",

    authDomain: "sead-b5e7b.firebaseapp.com",

    projectId: "sead-b5e7b",

    storageBucket: "sead-b5e7b.firebasestorage.app",

    messagingSenderId: "471503516767",

    appId: "1:471503516767:web:f5d7bbf71f1854d48857ea",

    measurementId: "G-WN0BLDJ1WJ"

  },

  cryptoKey: "AIzaSyCb0UoyEG1qGtfj6nTguKjPQ2Pp553cs8A---BDfrYMcW5-u4T1ABqtdpEEQz3590cz5RLWEPYoGpBr9oEbcVLF1MlYSppQ9JhZY9gzliEsi3zbIWz6ftohEG9Gw",
  vapidKey: "BDfrYMcW5-u4T1ABqtdpEEQz3590cz5RLWEPYoGpBr9oEbcVLF1MlYSppQ9JhZY9gzliEsi3zbIWz6ftohEG9Gw"
}
